// extracted by mini-css-extract-plugin
module.exports = {"icon":"_22HQpSPd","svg":"_26oO_ecM"};